import { cn } from "@/shared/utils/general/cn"

/**
 * Skeleton placeholder for the sidebar while data loads.
 *
 * Matches the real Sidebar layout exactly:
 *   - pt-10 + mt-[30px] container
 *   - px-5 outer, px-3 per row (matching SidebarItem padding)
 *   - gap-2.5 between icon + label (matching SidebarItem)
 *   - 24×24 icon area, text-base label height
 *   - Group gaps: mb-2.5 after Inbox, mb-2.5 after Someday, mt-5 before dynamic
 *
 * Uses foreground/8% for bars (blends naturally with sidebar tint)
 * instead of bg-muted (which is a neutral gray that clashes).
 */
export function SidebarSkeleton() {
  return (
    <div className="flex h-full flex-col bg-sidebar pt-10">
      <div className="mt-[30px] px-5">
        {/* Inbox */}
        <SkeletonNavItem width="38%" />
        <div className="mb-2.5" />

        {/* Today, Upcoming, Anyday, Someday */}
        <SkeletonNavItem width="34%" />
        <SkeletonNavItem width="48%" />
        <SkeletonNavItem width="40%" />
        <SkeletonNavItem width="44%" />
        <div className="mb-2.5" />

        {/* Logbook, Trash */}
        <SkeletonNavItem width="44%" />
        <SkeletonNavItem width="32%" />

        {/* Dynamic items (Areas / Projects / Lists) */}
        <div className="mt-5" />
        <SkeletonNavItem width="52%" />
        <SkeletonNavItem width="44%" indent />
        <SkeletonNavItem width="56%" indent />
        <SkeletonNavItem width="38%" indent />
      </div>
    </div>
  )
}

function SkeletonNavItem({
  width,
  indent,
}: {
  width: string
  indent?: boolean
}) {
  return (
    <div
      className={cn(
        "flex items-center gap-2.5 rounded-lg px-3 py-2",
        indent && "pl-5",
      )}
    >
      <div className="size-6 shrink-0 rounded-md bg-foreground/[0.06]" />
      <div
        className="h-4 rounded bg-foreground/[0.06]"
        style={{ width }}
      />
    </div>
  )
}
